import { useRoles } from '../utils'

import { Role } from '@/modules/adminUsers/roles'

export const useHasRoles = (
  roles: Role | Role[],
  trueWhileLoading?: boolean
) => {
  const { hasRole } = useRoles()

  return hasRole(Array.isArray(roles) ? roles : [roles], trueWhileLoading)
}
